import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
export default {
  getAllInWorkspace(workspaceUid) {
    return raw.getAll(routes.projectedAttachments.allInWorkspace(workspaceUid));
  },
  createInWorkspaceFromParent(workspaceUid, parentAttachmentUids) {
    return raw.post(routes.projectedAttachments.allInWorkspace(workspaceUid), {
      attachments: parentAttachmentUids,
    });
  },
  // Creates a new attachment in a workspace from a already-projected attachment UID
  createInWorkspaceFromProjectedUids(workspaceUid, projectedAttachmentUids) {
    return raw.post(routes.projectedAttachments.allInWorkspace(workspaceUid), {
      attachment_uids: projectedAttachmentUids,
    });
  },
  deleteInWorkspace(workspaceUid, attachmentUids) {
    return raw.delete({
      url: routes.projectedAttachments.allInWorkspace(workspaceUid),
      params: { attachment_uids: attachmentUids.join(",") },
    });
  },
};
